import _classCallCheck from '../../../../../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../../../../../@babel/runtime/helpers/esm/createClass.js';
import _assertThisInitialized from '../../../../../@babel/runtime/helpers/esm/assertThisInitialized.js';
import _inherits from '../../../../../@babel/runtime/helpers/esm/inherits.js';
import _createSuper from '../../../../../@babel/runtime/helpers/esm/createSuper.js';
import _defineProperty from '../../../../../@babel/runtime/helpers/esm/defineProperty.js';
import { Parser } from '../Parser.js';
import { parseAnyDigitsSigned } from '../utils.js';

var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampSecondsParser, _Parser);
  var _super = _createSuper(TimestampSecondsParser);
  function TimestampSecondsParser() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 40);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser;
}(Parser);

export { TimestampSecondsParser };
